import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["src", "srcSet", "sizes"];
import "core-js/modules/es6.array.map.js";

/* eslint-disable react/no-array-index-key */
import React from 'react';
import classNames from 'classnames'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import omit from 'lodash/omit';
import PropTypes from 'prop-types'; // eslint-disable-next-line import/no-unresolved -- directive added automatically by Shepherd migration

import classes from '@nerdwallet/base-styles/classes';
import styles from './image.module.less'; // Remove custom props that should not
// be applied to the DOM element

var omitExtraneous = function omitExtraneous(source) {
  return omit(source, ['aspectRatio', 'backgroundColor', 'caption', 'children', 'className', 'expandToContent', 'imageClassName', 'lazy', 'naturalHeight', 'naturalWidth', 'objectFit', 'objectPosition', 'offset', 'overflow', 'placeholderImage', 'sources']);
};

var Picture = function Picture(props) {
  var alt = props.alt,
      title = props.title,
      className = props.className,
      src = props.src,
      srcSet = props.srcSet,
      sizes = props.sizes,
      objectFit = props.objectFit,
      sources = props.sources,
      expandToContent = props.expandToContent,
      objectPosition = props.objectPosition,
      error = props.error,
      placeholderImage = props.placeholderImage,
      onLoad = props.onLoad;
  var imgProps = {
    alt: alt,
    title: title,
    className: classNames(className, styles.image, _defineProperty({}, classes('position-absolute'), expandToContent)),
    src: src,
    srcSet: srcSet,
    sizes: sizes,
    style: {
      objectPosition: objectPosition,
      objectFit: objectFit
    },
    onLoad: onLoad
  };

  if (error) {
    // Bail on sources, and render an img tag using placeholder image.
    delete imgProps.srcSet;
    imgProps.src = placeholderImage;
    /* `alt` is part of `imgProps` above. */

    /* eslint-disable-next-line jsx-a11y/alt-text */

    return /*#__PURE__*/React.createElement("img", imgProps);
  }

  var fallbackSrc; // Multiple sources return a <picture> element

  var sourceTags = sources.map(function (source, index) {
    var _omitExtraneous = omitExtraneous(source),
        sourceSrc = _omitExtraneous.src,
        sourceSrcSet = _omitExtraneous.srcSet,
        sourceSizes = _omitExtraneous.sizes,
        sourceProps = _objectWithoutProperties(_omitExtraneous, _excluded);

    if (sourceSrc && !fallbackSrc) {
      fallbackSrc = sourceSrc;
    }

    return /*#__PURE__*/React.createElement("source", _extends({}, sourceProps, {
      src: sourceSrc,
      srcSet: sourceSrcSet || sourceSrc,
      sizes: sourceSizes,
      key: index
    }));
  });
  return sources.length > 1 ? /*#__PURE__*/React.createElement("picture", null, sourceTags, /*#__PURE__*/React.createElement("img", _extends({}, imgProps, {
    src: src || fallbackSrc
  }))) :
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/alt-text
  React.createElement("img", _extends({}, imgProps, omitExtraneous(sources[0])));
};

Picture.displayName = 'Picture';
Picture.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  error: PropTypes.bool,
  expandToContent: PropTypes.bool,
  media: PropTypes.string,
  objectFit: PropTypes.string,
  objectPosition: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onLoad: PropTypes.func,
  placeholderImage: PropTypes.string,
  sources: PropTypes.arrayOf(PropTypes.shape({
    media: PropTypes.string,
    srcSet: PropTypes.string,
    sizes: PropTypes.string
  })),
  src: PropTypes.string,
  srcSet: PropTypes.string,
  sizes: PropTypes.string,
  title: PropTypes.string
};
Picture.defaultProps = {
  sources: []
};
export default Picture;